import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Team from './Team';
import CompanyInfos from './CompanyInfos';

const useStyles = makeStyles({
  root: {
    width: '75%',
    margin: '1rem auto',

    '& button': {
      textTransform: 'capitalize'
    },

    '& .Mui-selected': {
      fontWeight: 'bold',
      background: '#002380',
      color: '#FAFAFA',
      margin: '3px',
      borderRadius: '3px'
    }
  },
  content: {
    width: '80%',
    margin: '0 auto',
    textAlign: 'center'
  }
});

const TabNav = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper className={classes.root}>
        <Tabs
          centered
          indicatorColor="primary"
          onChange={handleChange}
          textColor="primary"
          value={value}>
          <Tab label="Company Informations" />
          <Tab label="Detailed Schedule" />
          <Tab label="Team" />
        </Tabs>
      </Paper>
      <div className={classes.content}>
        {value === 0 && <CompanyInfos />}
        {value === 1 && <h3>Detailed Schedule</h3>}
        {value === 2 && <Team />}
      </div>
    </>
  );
};

export default TabNav;
